module.exports = __webpack_public_path__ + "media/images/new-card-image-d9b376fc5201679f48454b51b5ff570c.svg";